import { useState, useEffect } from 'react';
import axios from 'axios';

const useAdaptiveData = (currentData) => {
  const [adaptiveData, setAdaptiveData] = useState([]);
  const [adaptiveForecastData, setAdaptiveForecastData] = useState([]);
  const [poData, setPoData] = useState([]);
  const [adaptiveActuals, setAdaptiveActuals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentData?.netSuiteId || !currentData?.afeNumber) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const [adaptiveDataRes, adaptiveForecastRes, poDataRes, adaptiveActualsRes] = await Promise.all([
          axios.get(`/api/LandingWarehouse/Adaptive/ProjectSummary/${currentData.netSuiteId}`),
          axios.get(`/api/LandingWarehouse/Adaptive/CapexForecast/${currentData.netSuiteId}`),
          axios.get(`/api/LandingWarehouse/NetSuite/PurchaseOrders/${currentData.afeNumber}`),
          axios.get(`/api/LandingWarehouse/Adaptive/Actuals/${currentData.netSuiteId}`),
        ]);

        const sortByMonthYear = (data) =>
          Array.isArray(data) ? [...data].sort((a, b) => a.monthYear.localeCompare(b.monthYear)) : [];

        setAdaptiveData(sortByMonthYear(adaptiveDataRes.data));
        setAdaptiveForecastData(sortByMonthYear(adaptiveForecastRes.data));
        setPoData(poDataRes.data || []);
        setAdaptiveActuals(sortByMonthYear(adaptiveActualsRes.data));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentData]);

  return { adaptiveData, adaptiveForecastData, poData, adaptiveActuals, loading, error };
};

export default useAdaptiveData;
